<template>
    <v-app>
        <v-main>
            <v-container fluid class="pa-0 fill-height">
                <v-row class="auth-layout fill-height" no-gutters>
                    <v-col id="auth-bgimage-wrapper">
                        <v-img id="auth-bgimage" width="100%" content-class="auth-bgimage-responsive-content" :src="authImage">
                            <div class="fill-height transparent-square"></div>
                            <div class="fill-height cut-square"></div>
                        </v-img>
                    </v-col>

                    <v-col class="auth-responsive-mt d-flex flex-column align-center justify-space-between" id="auth-content">
                        <div class="auth-language-switcher">
                            <v-btn-toggle :value="$i18n.locale" mandatory dense rounded @change="switchLanguage">
                                <v-btn small value="pt" :title="'Português'" aria-label="Português" data-cy="auth-lang-pt">PT</v-btn>
                                <v-btn small value="en" :title="'English'" aria-label="English" data-cy="auth-lang-en">EN</v-btn>
                            </v-btn-toggle>
                        </div>

                        <div class="d-flex flex-column align-center">
                            <v-img contain class="mx-auto mb-6 responsive-auth-logo" src="/storage/assets/auth_simbolo.png"  style="margin-top:100px;"></v-img>
                            <!--<v-img contain class="mx-auto mb-2 responsive-auth-name" src="/storage/assets/auth_simbolo_texto.png"></v-img>-->

                            <slot />
                        </div>
                        <div>
                            <p class="d-flex justify-center auth-legal-text mt-4" style="color: darkgrey; text-align: center">© {{ $t('layout.copyright') }} {{ currentYear }}</p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>

        <t-notifications></t-notifications>
    </v-app>
</template>

<script>
import TNotifications from './TNotifications';
import { axios } from '@/Services/Backend';
import { getPublicLocale, setPublicLocale } from '@/i18n';

export default {
    components: { TNotifications },

    data: () => ({
        authImage: '',
        currentYear: new Date().getFullYear(),
    }),

    created() {
        // Public pages have no user, so the language chosen here is kept in the browser
        setPublicLocale(getPublicLocale());

        axios
            .get('/api/images/auth-background')
            .then((response) => {
                this.authImage = response.data.imgUrl;
            })
            .catch(() => {
                this.authImage = '/storage/assets/auth_background.png';
            });
    },

    methods: {
        switchLanguage(locale) {
            if (locale) setPublicLocale(locale);
        },
    },
};
</script>

<style>
/* Pill toggle: blue outline, active option filled blue. */
.auth-language-switcher .v-btn-toggle {
    border: 1px solid #006db6;
    border-radius: 999px !important;
    background: #fff !important;
    overflow: hidden;
}

.auth-language-switcher .v-btn-toggle .v-btn {
    min-width: 48px !important;
    height: 28px !important;
    border: none !important;
    border-radius: 999px !important;
    background: transparent !important;
    color: #006db6 !important;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    opacity: 1;
}

.auth-language-switcher .v-btn-toggle .v-btn.v-btn--active {
    background: #006db6 !important;
    color: #fff !important;
}

.auth-language-switcher .v-btn-toggle .v-btn::before {
    display: none;
}

html {
    overflow-y: auto !important;
    -ms-overflow-style: none; /* IE 11 */
    scrollbar-width: none; /* Firefox 64 */
}
</style>

<style scoped>
.auth-language-switcher {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 10;
}

/* Always active. */
#auth-bgimage {
    height: max(100%, 100vh);
}

.auth-legal-text {
    font-size: 0.7rem !important;
    font-weight: 500;
    line-height: 1.375rem;
}

@media only screen and (min-width: 1025px) {
    #auth-content {
        min-width: 600px;
        max-width: 600px;
        padding-left: 8px;
        padding-right: 64px;
    }

    #auth-bgimage-wrapper {
        width: 1%;
        max-height: 100vh;
        max-height: 100dvh;
    }
}

@media only screen and (max-width: 1024px) {
    #auth-bgimage-wrapper {
        display: none !important;
    }
    #auth-content {
        padding-left: 64px;
        padding-right: 64px;
    }
    .auth-layout {
        align-content: center !important;
        justify-content: center !important;
    }
}

@media only screen and (max-width: 580px) {
    #auth-content {
        padding-left: 24px;
        padding-right: 24px;
    }
}

.transparent-square {
    --transparent-area-size: 15px;

    content: '';
    background: rgba(255, 255, 255, 0.5);
    width: 215%;
    height: 120%;
    position: absolute;

    /* Calculate the average of the left and right shapes, and then add `transparent-area-size` for the transparent area */
    transform: rotate(185deg) translate(calc(calc(calc(-42% + -44%) / 2) + var(--transparent-area-size)), 0);
}

.cut-square {
    content: '';
    background: rgba(255, 255, 255, 1);
    width: 215%;
    height: 120%;
    position: absolute;

    transform: rotate(185deg) translate(calc(calc(-42% + -44%) / 2), 0);
}

.no-underline {
    text-decoration: none;
}
</style>
